(function($) {
	"use strict";

	$(document).ready(function($) {

		$('.grant-application-block').each(function(index) {

				var open = new Date($(this).data('open'));
				var closed = new Date($(this).data('closed'));

				var today = new Date();
				var text;
				var icon;

				// Open before today, closed after today
				if(open < today && closed > today) {
					text = 'Application Open';
					icon = 'icon icon- icon-checkmark';
					var primary = 'imgbox-footer--primary';
					$(this).find('.imgbox-footer').addClass('imgbox-footer--primary');

				// Closed date is before today
				} else if(closed < today) {
					text = 'Application Closed';
					icon = 'icon icon-closed';

				// Open date in future
				} else {
					var options = { month: 'short', year: 'numeric' };
					var openDate = open.toLocaleDateString('en-US', options);
					text = 'Application Opens ' + openDate;
					icon = 'icon icon-calendar';
				}

				// Create out icon and append the text
				var span = $(document.createElement('span'));
				span.addClass(icon);

				$(this).find('.imgbox-footer').html('<span class="' + icon + '"></span> ' + text);
		});

	}); // end.ready

}(jQuery));
